export default __webpack_public_path__ + "static/media/single2.2da642488005acdb7f5c193eafc578b7.svg";